import { useState } from "react";

export default function ButtonHooks() {
  const [onClick, setOnClick] = useState(false);
  const [onClickSecondary, setOnClickSecondary] = useState(false);

  return { onClick, setOnClick, onClickSecondary, setOnClickSecondary };
}
